import {pageInfo, initUpdate, editData, exportData} from "../../toxinInspectResult/api";

const toxinInspectResult = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initUpdateObj: null,
    updateResp: null,
    exportObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [item.isCanToxinInspectResult == 'Y',true] }));
    },
    UPDATE_INIT_DATA(state, data){
      state.initUpdateObj = data.obj;
    },
    UPDATE_DATA(state, data){
      state.updateResp = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //修改初始化
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('UPDATE_INIT_DATA', resp);
    },
    //毒素检查结果提交
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('UPDATE_DATA', resp);
    },
    //毒素结果录入导出
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
  }
}
export default toxinInspectResult



// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectResult/store/toxinInspectResult.store.js